import { render, staticRenderFns } from "./FeedContentHeader.vue?vue&type=template&id=ead2089c&"
import script from "./FeedContentHeader.vue?vue&type=script&lang=ts&"
export * from "./FeedContentHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports